import { dwgl } from '@/axios'
import { Message } from 'element-ui'
import {bsid} from '@/common/common.js'
let that;
export default{
	data(){
		return{
			// 分类列表
			classList:[
				{name:"工作执行",id:"1"},
				{name:"思想建设",id:"2"},
				{name:"组织管理",id:"3"},
				{name:"班子建设",id:"4"},
				{name:"党风廉政",id:"5"},
				{name:"服务基层",id:"6"},
				{name:"其他公示",id:"7"},
			],
			imageUrl:"",
			isUploaded:"上传封面图",
			formData:{
				id:"",//编辑时所用数据id
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				title:"",
				sz_img:"",
				class_id:"",
				day:"",
				content:"",
				files:[]
			},
			rules:{
				// 检测标题是否为空
				title: [
					{ required: true, message: '请输入标题', trigger: 'blur' }
				],
				// 检测分类是否为空
				class_id: [
					{ required: true, message: '请选择类型', trigger: 'blur' }
				]
			}
		}
	},
	mounted() {
		if(that.$route.query.type == 'edit'){
			that.getdata();//编辑时渲染数据
		}
	},
	created() {
		that = this;
	},
	methods:{
		// 编辑时获取数据
		getdata(){
			dwgl.updatePartyAffairsGet({
				id:that.$route.query.id
			}).then(res => {
				if(res.code == 200){
					for(let key in res.data){
						for(let val in that.formData){
							if(key == val){
								that.formData[val] = res.data[key]
							}
						}
					}
					that.imageUrl = res.data.sz_img
					if(res.data.sz_img == ""){
						that.isUploaded = "上传封面图"
					}else{
						that.isUploaded = "重新上传"
					}
				}else{
					Message.error(res.msg)
				}
			})
		},
		//提交
		submit(formData){
			that.$refs[formData].validate((valid) => {
				if (valid) {
					if(that.$route.query.type == 'edit'){
						dwgl.updatePartyAffairs(that.formData).then(res => {
							if(res.code == 200){
								Message({
									type:"success",
									message:"成功"
								})
								that.$router.go(-1)
							}else{
								Message.error(res.msg)
							}
						})
					}else{
						dwgl.addPartyAffairs(that.formData).then(res => {
							if(res.code == 200){
								Message({
									type:"success",
									message:"成功"
								})
								that.$router.go(-1)
							}else{
								Message.error(res.msg)
							}
						})
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 上传封面图成功
		success(res, file) {
			if(res.code == 200){
				that.imageUrl = URL.createObjectURL(file.raw);
				that.isUploaded = "重新上传"
				that.formData.sz_img = res.data.src
			}else{
				Message({
					type:"error",
					message:"上传失败，请检查文件或网络连接"
				})
			}
		},
		// 上传文件成功
		success1(res, file) {
			if(res.code == 200){
				let data = {
					bsid:bsid(res.data.src),
					title:res.data.title,
					ment_url:res.data.src
				}
				that.formData.files.push(data);
			}else{
				Message.error("上传失败")
			}
		},
		// 上传进度
		uploadProcess(event, file, fileList) {
			const loading = this.$loading({
				lock: true,
				text: '上传中请稍后',
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.7)'
			});
			if(Math.floor(event.percent) == 100){
				loading.close();
			}
		},
		// 删除文件
		delfile(index){
			that.formData.files.splice(index,1)
		}
	}
}